import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import DefaultIcon from './Default/index.js';
import NavigationIcon from './Navigation/index.js';
import BrandIcon from './Brands/index.js';
import Loading from './LoadingIcon/index.js';
import GoogleIcon from './GoogleIcon/index.js';
import VariantIcon from './VariantIcon.js';
import CustomizableIcons from './CustomizableIcons/index.js';
import Social from './Social/index.js';
import Activity from './Activity/index.js';
import Payment from './Payment/index.js';

var _excluded = ["icon", "type", "width", "height", "color", "className"];
var Icons = Object.assign({}, Activity, DefaultIcon, BrandIcon, NavigationIcon, Social, {
  Loading: Loading,
  Google: GoogleIcon
}, CustomizableIcons, Payment);
var Icon = function Icon(_ref) {
  var icon = _ref.icon,
    type = _ref.type,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '56' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '56' : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#120A20' : _ref$color,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (icon) {
    return /*#__PURE__*/React.createElement(VariantIcon, _extends({}, props, {
      width: width,
      height: height,
      className: className,
      icon: icon
    }));
  }
  /**
   * example usage 1: <Icon.Loading />
   * example usage 2: <Icon type="loading" />
   *
  */

  var Component = Icons[type];
  if (typeof Component === 'undefined') return null;
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    style: {
      color: color
    }
  }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    width: width,
    height: height,
    color: color
  })));
};
Icon.Customizable = CustomizableIcons;
Icon.Navigation = NavigationIcon;
Icon.Brand = BrandIcon;
Icon.Loading = Loading;
Icon.Google = GoogleIcon;
Icon.Default = DefaultIcon;
Icon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /* Not all icons accept color (e.g tada)*/
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /* if this prop is passed component uses old version of Icon aka VariantIcon */
  icon: PropTypes.any,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export { Icons, Icon as default };
//# sourceMappingURL=index.js.map
